import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const editCollection = async ({ data }) => {
  const user = getUserDetails();
  const response = await axios.put(
    `${API_BACKEND_URL}/collections/updateCollection?companyId=${user.companyid}`,
    data,
  );
  return response.data;
};

export const useEditCollection = (options = {}) => {
  return useMutation({
    mutationFn: editCollection,
    ...options,
  });
};
